import React from 'react';
import {
  FpLogo,
  FsLogo,
  InLogo,
  InwLogo,
  JldLogo,
  JwtLogo,
  MaLogo,
  NwLogo,
  ProvallianceLogo,
  SaLogo,
  TbcLogo,
  CcoLogo,
  ColLogo
} from '.';

const BrandLogo = ({ code, ...other }) => {
  const components = {
    fp: FpLogo,
    fs: FsLogo,
    in: InLogo,
    inw: InwLogo,
    jld: JldLogo,
    jwt: JwtLogo,
    ma: MaLogo,
    nw: NwLogo,
    sa: SaLogo,
    tbc: TbcLogo,
    cco: CcoLogo,
    col: ColLogo
  };

  const Component = components[code] || ProvallianceLogo;

  return <Component {...other} />;
};

export default BrandLogo;
